<template>
    <div class="root">
        <div class="title">
            {{title}}
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoBubbleContainer",
        props:{
            title: String
        }
    }
</script>

<style scoped>
    .root{
        position: relative;
    }

    .title{
        padding-left: 1em;
        padding-bottom: 2px;
        font-size: 0.7em;
        color: #777;
        pointer-events: none;
        transition: 0.2s ease all;
    }
</style>